import { render } from "./ViewTests.vue?vue&type=template&id=f288d6a0"
import script from "./ViewTests.vue?vue&type=script&lang=js"
export * from "./ViewTests.vue?vue&type=script&lang=js"

import "./ViewTests.vue?vue&type=style&index=0&id=f288d6a0&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ViewTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f288d6a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f288d6a0', __exports__)) {
    console.log('reload')
    api.reload('f288d6a0', __exports__)
  }
  
  module.hot.accept("./ViewTests.vue?vue&type=template&id=f288d6a0", () => {
    console.log('re-render')
    api.rerender('f288d6a0', render)
  })

}


export default __exports__